import RoutesMap from "../../route_control/RouteControl"
import { lazy } from "react"

const CountryList = lazy(() => import('../../pages/master/country/CountryList'));
const StateList = lazy(() => import('../../pages/master/state/StateList'));
const DistrictList = lazy(() => import('../../pages/master/district/DistrictList'));
const TehsilList = lazy(() => import('../../pages/master/tehsil/TehsilList'));
const NatureList = lazy(() => import('../../pages/master/nature/NatureList'));
const StructureList = lazy(() => import('../../pages/master/structure/StructureList'));
const CropList = lazy(() => import('../../pages/master/crop/CropList'));
const BioMasterList = lazy(() => import('../../pages/master/bio_master/BioMasterList'));
const DiseaseMasterList = lazy(() => import('../../pages/master/disease_master/DiseaseMasterList'));
const StageList = lazy(() => import('../../pages/master/stage/StageList'));
const RequestTypeList = lazy(() => import('../../pages/master/request_type/RequestTypeList'));

export const MasterImport = {
    RoutesMap,
    CountryList,
    StateList,
    DistrictList,
    TehsilList,
    NatureList,
    StructureList,
    CropList,
    BioMasterList,
    DiseaseMasterList,
    StageList,
    RequestTypeList,
}